import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Browser } from '@capacitor/browser';
import { backendUrl } from 'src/environments/environment';
import { toPromise } from './toPromise';
import { Category } from './category.store';
import { Seller } from './authentication.store';

export interface BannerResponse {
  status: Boolean;
  data: Array<Banner>;
}

export interface AdvertisementResponse {
  status: Boolean;
  data: Array<Advertisement>;
}
export interface Advertisement {
  id: number;
  name: string;
  type: number;
  category_id: number;
  seller_id: number;
  external_link: string;
  img: string;
  status: number;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date;
  slug: string;
  category: Category;
  seller: Seller;
}

export interface Banner {
  id?: number;
  name: string;
  type: number;
  category_id?: number;
  seller_id?: number;
  external_link?: string;
  img: string;
  product_id?: number;
  created_at?: Date;
  updated_at?: Date;
  deleted_at?: Date;
  linking_url: string;
  slug: string;
}

export enum BannerType {
  /* eslint-disable no-unused-vars */
  Category,
  Shop,
  External,
  Product,
  /* eslint-enable no-unused-vars */
}

@Injectable({
  providedIn: 'root',
})
export class BannerStore {
  constructor(private httpClient: HttpClient, private router: Router) {}

  async getBanner(params = null): Promise<BannerResponse> {
    const url = `${backendUrl}banner`;
    return toPromise(
      this.httpClient.get<BannerResponse>(url, {
        params: params,
        headers: new HttpHeaders({}),
      })
    );
  }
  async getAdvertisement(params = null): Promise<AdvertisementResponse> {
    const url = `${backendUrl}advertisement`;
    return toPromise(
      this.httpClient.get<AdvertisementResponse>(url, {
        params: params,
        headers: new HttpHeaders({}),
      })
    );
  }

  bannerRedirect(banner: any) {
    switch (banner.type) {
      case BannerType.Category:
        this.router.navigate(['/category/' + banner?.category?.slug]);
        break;
      case BannerType.Shop:
        this.router.navigate(['/shop/' + banner?.seller.slug]);
        break;
      case BannerType.Product:
        if (banner.product_id) {
          this.router.navigate(['/product/' + banner.slug]);
        }
        break;
      case BannerType.External:
        Browser.open({ url: banner.external_link });
        break;
    }
  }

  advertisementRedirect(advertisement: Advertisement) {
    switch (advertisement.type) {
      case BannerType.Category:
        this.router.navigate(['/category/' + advertisement?.category?.slug]);
        break;
      case BannerType.Shop:
        this.router.navigate(['/shop/' + advertisement?.seller.slug]);
        break;
      case BannerType.External:
        Browser.open({ url: advertisement.external_link });
        break;
    }
  }
}
